import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Urls } from "../../../utils/constant";
import { useApi } from "../apiCall/useApi";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setAreaList } from "../../reducers/Area/area.reducer";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";

const COLUMN_LIST = [
  // { field: "customer_id", headerName: "ID", hide: true },
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },

  {
    field: "name",
    headerName: "Area Name",
    flex: 1,
  },
  {
    field: "address",
    headerName: "Address",
    flex: 1,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "Active" },
  { id: 2, label: "In-Active" },
];

export default function useArea() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [Name, setName] = useState("");
  const [status, setStatus] = useState(1);

  const fetchAreaList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.areaGet(),
          data: {
            id: "",
            name: Name,
            page_size: row_count,
            current_page: current_page,
            status: StatusVal,
          },
        });
        // setting list to reducer
        dispatch(setAreaList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, dispatch, status, apiPost, Name]
  );

  const handleNameChange = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    Name,
    handleNameChange,
    handleStatusChange,
    fetchAreaList,
  };
}
